
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { ScoreChart } from './ScoreChart';

interface AssessmentScoreSectionProps {
  scores: Record<string, { score: number; maxScore: number }>;
  overallScore: number;
  scoreLevel: {
    level: string;
    color: string;
    icon: string;
    description: string;
  };
  axisColors?: Record<string, string>;
}

export const AssessmentScoreSection: React.FC<AssessmentScoreSectionProps> = ({
  scores,
  overallScore,
  scoreLevel,
  axisColors,
}) => {
  const color = scoreLevel.color;

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 items-stretch">
      {/* === Encart 1 : Score global === */}
      <Card
        className="border-2 overflow-hidden"
        style={{
          borderColor: `${color}33`,
          background: `linear-gradient(135deg, ${color}0D 0%, ${color}1A 100%)`,
        }}
      >
        <CardContent className="p-3 md:p-5 h-full">
          <div className="flex flex-col items-center text-center gap-6 h-full justify-center">
            {/* Badge rond avec le % */}
            <div
              className="flex-shrink-0 rounded-full flex items-center justify-center shadow-lg p-3 md:p-4"
              style={{
                width: '90px',
                height: '90px',
                background: `linear-gradient(135deg, ${color} 0%, ${color}CC 100%)`,
                boxShadow: `0 10px 30px -10px ${color}66`,
              }}
              aria-label={`Score global ${overallScore}%`}
            >
              <span className="text-white font-extrabold text-3xl md:text-4xl leading-none">
                {overallScore}%
              </span>
            </div>

            {/* Texte sous le badge */}
            <div className="flex-1 text-center">
              <p
                className="text-xs md:text-sm font-semibold uppercase tracking-widest mb-1.5"
                style={{ color: `${color}` }}
              >
                Votre score global
              </p>
              <h3
                className="text-2xl md:text-3xl font-bold mb-2 leading-tight"
                style={{ color }}
              >
                Niveau&nbsp;: {scoreLevel.level}
              </h3>
              <p className="text-base md:text-lg text-gray-700 leading-relaxed">
                {scoreLevel.description}
              </p>
            </div>
          </div>
        </CardContent>
      </Card>

      {/* === Encart 2 : Radar (pleine largeur) === */}
      <Card className="border-2 border-gray-100">
        <CardContent className="p-3 md:p-4">
          <div className="w-full">
            <ScoreChart scores={scores} axisColors={axisColors} />
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
